/** @format */

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Link, useNavigate } from "react-router-dom";
import * as formik from "formik";
import * as yup from "yup";
import { useUserSignIn } from "../../../../api/mutations/auth.mutation";
import useAuth from "src/components/hooks/useAuth.js";

function SignInForm() {
  const { Formik } = formik;

  const schema = yup.object().shape({
    email: yup.string().required("Please enter your email"),
    password: yup.string().required("Please enter your password"),
    rememberMe: yup.bool(),
  });

  const { successfulUserSignIn } = useAuth();

  const userLoginMutation = useUserSignIn({
    onSuccess: (data) => {
      console.log("Sign-in-form", data);
      successfulUserSignIn(data);
    },
    onError: (error) => {
      if (error.message) {
      }
    },
    successMessage: "Login Successful!",
  });

  const onSignIn = (data) => {
    console.log(data);
    userLoginMutation.mutate({
      password: data.password,
      email: data.email,
      remember: data.rememberMe,
    });
  };

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSignIn}
      initialValues={{
        email: "",
        password: "",
        rememberMe: false,
      }}
    >
      {({ handleSubmit, handleChange, values, touched, errors }) => (
        <Form noValidate onSubmit={handleSubmit} className="mt-5">
          <Row className="mb-3">
            <Form.Group
              as={Col}
              controlId="validationFormikEmail"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Username or Email Address
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="Your Full Name"
                name="email"
                value={values.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group
              as={Col}
              controlId="validationFormikPassword"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Your Password
              </Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                name="password"
                value={values.password}
                onChange={handleChange}
                isInvalid={!!errors.password}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="d-flex align-items-center justify-content-between">
            <Form.Group
              controlId="validationFormikTerms"
              className="form-check d-inline-block m-0"
            >
              <Form.Check
                type="checkbox"
                name="rememberMe"
                onChange={handleChange}
                isInvalid={!!errors.rememberMe}
                feedback={errors.rememberMe}
                feedbackType="invalid"
              />
              <Form.Label>Remember Me</Form.Label>
            </Form.Group>
            <Link to="/auth/forgotpw" className="font-italic">
              Forgot Password?
            </Link>
          </div>
          <Button
            variant="success"
            type="submit"
            className="btn btn-success mt-4 fw-semibold text-uppercase w-100"
          >
            Sign in
          </Button>
          <h6 className="mt-5">
            Don't Have An Account? <Link to="/auth/sign-up">Sign Up</Link>
          </h6>
        </Form>
      )}
    </Formik>
  );
}

export default SignInForm;
